import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap'

import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { API, INestedProduct } from '@getgreenline/homi-shared'
import { parseErrorMsg } from '../../../../../utilities/helpers'
import { message } from 'antd'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  mode: 'standalone' | 'variant'
  parentName: string
  productId: string
  productName: string
  onHide: () => void
  onSubmit: (product: INestedProduct) => void
}

interface State {
  confirmed: boolean
  newName: string
}

@inject('currentCompanyStore')
@observer
export class ConvertVariantModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const { parentName, productName } = props
    this.state = {
      confirmed: false,
      newName: parentName + ' - ' + productName,
    }
  }

  async convert() {
    const company = this.props.currentCompanyStore!.company!
    const { productId } = this.props
    const { newName } = this.state

    try {
      let newProduct: INestedProduct
      if (this.props.mode === 'standalone') {
        newProduct = await API.splitProduct(company.id, productId, newName)
      } else {
        newProduct = await API.splitProductToVariant(company.id, productId, newName)
      }

      message.success('Product successfully converted')
      this.props.onSubmit(newProduct)
    } catch (error) {
      message.error(parseErrorMsg(error) || 'There was an error converting this variant.')
    }
  }

  render() {
    const { confirmed, newName } = this.state

    return (
      <Modal isOpen={true} toggle={() => this.props.onHide()} autoFocus={false}>
        <ModalHeader toggle={() => this.props.onHide()}>Split variant</ModalHeader>
        <ModalBody className='text-s-center'>
          {!confirmed ? (
            <>
              <div>
                {this.props.mode === 'variant'
                  ? 'This will create a new product with this item as a variant.'
                  : 'This will move this variant item into a standalone product.'}
              </div>
              <p className='mb-4'>Your inventory and sales history will not be affected.</p>

              <Button
                className='btn btn-lg btn-light w-100'
                onClick={() => this.setState({ confirmed: true })}
              >
                Continue
              </Button>
            </>
          ) : (
            <>
              <div className='form-group mb-4'>
                <label className='form-label'>
                  What do you want to name{' '}
                  {this.props.mode === 'variant' ? 'the parent product' : 'this product'}?
                </label>
                <input
                  className='form-control'
                  value={newName}
                  onChange={(e) => this.setState({ newName: e.target.value })}
                />
              </div>
              <Button
                className='btn btn-lg btn-success w-100'
                disabled={!newName}
                onClick={() => this.convert()}
              >
                Convert
              </Button>
            </>
          )}
        </ModalBody>
      </Modal>
    )
  }
}
